import { FilterIcon, FiltersPopover, SearchInput, Typography, palette } from '@dev/ee-components';
import { findIndex, flatten } from 'lodash-es';

import { Grid } from '@material-ui/core';
import React from 'react';
import { STALE_CONTACTS_RULES } from '@/components/Contacts/consts';
import Skeleton from 'react-loading-skeleton';
import clsx from 'clsx';
import { debounce } from '@/services/tools/debounce';
import useMobile from '@/services/hooks/useMobile';
import { useTranslation } from 'react-i18next';
import { useContactsAvailableStatuses } from '../../hooks/useContactsAvailableStatuses';
import { StaleContactsAlert } from './components/StaleContactsAlert';
import { useContactQueryParams, useSelectedEntity } from '../../hooks';
import { ContactHeaders, IconWrapper, RuleWrapper, SearchWrapper } from '../StyledComponents';

export const TopFiltersWithSearch = () => {
    const { t } = useTranslation();

    const isMobile = useMobile();
    const { selectedEntity, isSelectedEntityAList } = useSelectedEntity();
    const availableContactStatuses = useContactsAvailableStatuses();

    const isList = isSelectedEntityAList(selectedEntity);
    const { querySearch, queryStatuses, pushParamToUrl } = useContactQueryParams();

    const defaultStatuses = flatten(queryStatuses) || [];

    const handleSearch = (e?: React.ChangeEvent<HTMLInputElement>): void => {
        debounce(() => {
            pushParamToUrl({ search: e?.target?.value });
        }, 600);
    };

    const handleMobileFilterClick = (selectedItems: Record<'status', 'any'>) => {
        const selectedStatuses = selectedItems?.status;
        pushParamToUrl({ statuses: selectedStatuses });
    };

    return (
        <>
            {!isList && findIndex(STALE_CONTACTS_RULES, (rule): boolean => rule === selectedEntity?.Rule) > -1 && (
                <StaleContactsAlert />
            )}
            <ContactHeaders isMobile={isMobile}>
                {!isList && (
                    <RuleWrapper isMobile={isMobile}>
                        <Typography variant="h2" style={{ paddingRight: '12px' }}>
                            {t('rule')}: {selectedEntity?.Rule || <Skeleton />}
                        </Typography>
                    </RuleWrapper>
                )}
                <SearchWrapper className={clsx({ fullScreen: isList })} isMobile={isMobile}>
                    <SearchInput
                        id="search-for-contacts-input"
                        label=""
                        placeholder={t('searchforcontacts')}
                        type="text"
                        defaultValue={querySearch}
                        onChange={handleSearch}
                        onDelete={handleSearch}
                    />
                    {isMobile && (
                        <Grid item style={{ marginLeft: 16 }}>
                            <IconWrapper>
                                <FiltersPopover
                                    title={t('status')}
                                    tabs={[
                                        {
                                            id: 'status',
                                            label: t('status'),
                                            options: availableContactStatuses,
                                            type: 'checkbox',
                                            defaultCheckboxValue: defaultStatuses,
                                        },
                                    ]}
                                    translations={{ apply: t('apply'), close: t('close') }}
                                    onApply={handleMobileFilterClick}
                                >
                                    <FilterIcon color={palette.gray[6]} height={20} width={20} />
                                </FiltersPopover>
                            </IconWrapper>
                        </Grid>
                    )}
                </SearchWrapper>
            </ContactHeaders>
        </>
    );
};
